import { isNumber } from 'lodash';

import { LoadingCircleSpinner } from '../Loaders';

import { ProgressWrapper, Wrapper } from './TagItem.styles';

type Props = {
  name: string;
  progress?: number;
  isChecked: boolean;
  onClick: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
};

export const TagItem: React.FC<Props> = ({
  name,
  isChecked,
  progress,
  onClick,
  isDisabled = false,
  isLoading = false
}) => {
  return (
    <Wrapper
      onClick={() => !isLoading && onClick()}
      $isChecked={isChecked}
      $isDisabled={isDisabled}
      $hasProgress={isNumber(progress)}>
      {isLoading && <LoadingCircleSpinner size={14} />}
      {name}
      {isNumber(progress) && <ProgressWrapper $isChecked={isChecked}>{progress}%</ProgressWrapper>}
    </Wrapper>
  );
};
